// eslint-disable-next-line no-unused-vars
import { LoadingOutlined } from "@ant-design/icons";
import {
  // eslint-disable-next-line no-unused-vars
  Alert,
  // eslint-disable-next-line no-unused-vars
  Button,
  // eslint-disable-next-line no-unused-vars
  Col,
  // eslint-disable-next-line no-unused-vars
  Form,
  // eslint-disable-next-line no-unused-vars
  Input,
  // eslint-disable-next-line no-unused-vars
  Modal,
  // eslint-disable-next-line no-unused-vars
  Row,
  // eslint-disable-next-line no-unused-vars
  Spin,
  message,
} from "antd";
// eslint-disable-next-line no-unused-vars
import TextArea from "antd/lib/input/TextArea";
import { useEffect, useRef, useState } from "react";
import SimpleReactValidator from "simple-react-validator";
import { SimpleReactValidatorHelper } from "../../helpers/SimpleReactValidatorHelper";
import { translate } from "../../locale";
import CompanyServices from "../../services/CompanyServices";
// eslint-disable-next-line no-unused-vars
import PropTypes from "prop-types";
// eslint-disable-next-line no-unused-vars
import PickVademecum from "../PickVademecum";

const AddCompany = ({ visible, onComplete, onCancel }) => {
  const [loading, setLoading] = useState(false);
  const [active, setActive] = useState(false);
  const [values, setValues] = useState({
    name: "",
    terms: "",
    vademecum: [],
  });
  const [error, setError] = useState("");
  const [, forceUpdate] = useState();

  const simpleValidator = useRef(
    new SimpleReactValidator({
      autoForceUpdate: { forceUpdate: forceUpdate },
      element: SimpleReactValidatorHelper.elementMessage,
      messages: {
        required: "Campo requerido",
      },
    })
  );

  useEffect(() => {
    if (visible !== null) {
      setActive(visible);
    }
  }, [visible]);

  const disabled = () => !simpleValidator.current.allValid();

  const onFinish = async () => {
    setLoading(true);
    setError("");
    if (!simpleValidator.current.allValid()) {
      simpleValidator.current.showMessages();
      forceUpdate();
      setError("Todos los datos son requeridos");
      return;
    }
    try {
      const data = {
        name: values.name,
        terms_conditions: values.terms,
        vademecums: values.vademecum,
      };
      const res = await CompanyServices.updateCompany(data);
      if (res) {
        if (res.status >= 200 && res.status < 300) {
          message.success(
            "La {0} se guardó exitosamente.",
            translate("empresa")
          );
        } else if (res.data.detail) {
          message.error(res.data.detail, 6);
        } else {
          message.success(res.data.message, 6);
        }
        resetForm();
        setLoading(false);
        if (onComplete) {
          onComplete();
        }
      } else {
        setError("Add company error");
      }
    } catch (e) {
      console.log(e);
      setError(e.message);
      setLoading(false);
    }
  };

  const resetForm = () => {
    setValues({
      name: "",
      terms: "",
      vademecum: [],
    });
    simpleValidator.current.hideMessages();
    simpleValidator.current.visibleFields = [];
    forceUpdate();
  };

  const handleChange = (name, value) => {
    setValues((v) => ({ ...v, [name]: value }));
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    simpleValidator.current.showMessageFor(name);
    setValues((v) => ({ ...v, [name]: value }));
  };

  const handleCancel = () => {
    resetForm();
    setActive(false);
    if (onCancel) {
      onCancel();
    }
  };

  const handleAddVademecum = (id) => {
    setValues((prevValues) => {
      const isSelected = prevValues.vademecum.includes(id);
      const newVademecum = isSelected
        ? prevValues.vademecum.filter((vid) => vid !== id)
        : [...prevValues.vademecum, id];

      return { ...prevValues, vademecum: newVademecum };
    });
  };

  return (
    <Modal
      open={active}
      title={translate("Agregar Empresa")}
      onOk={null}
      onCancel={handleCancel}
      footer={false}
    >
      {error && (
        <Alert
          message={error}
          type="error"
          className="mb-6"
          closable
          onClose={() => setError("")}
        />
      )}
      <Form
        initialValues={{ remember: true }}
        onFinish={onFinish}
        autoComplete="off"
        className="w-full"
      >
        <Form.Item>
          <Input
            placeholder="Nombre"
            className="border-custom_primary"
            name="name"
            onChange={(e) => handleChange("name", e.target.value)}
            onBlur={handleBlur}
            value={values.name}
          />
          {simpleValidator.current.message("name", values.name, "required")}
        </Form.Item>

        <Form.Item>
          <TextArea
            placeholder="Términos y condiciones"
            className="border-custom_primary"
            name="terms"
            onChange={(e) => handleChange("terms", e.target.value)}
            onBlur={handleBlur}
            value={values.terms}
          />
          {simpleValidator.current.message("terms", values.terms, "required")}
        </Form.Item>
        <Form.Item>
          <PickVademecum
            onClickVademecum={handleAddVademecum}
            values={values}
          />
        </Form.Item>
        <Form.Item>
          <Row align="end" gutter={16}>
            <Col>
              <Button key="back" onClick={handleCancel}>
                {translate("Cancelar")}
              </Button>
            </Col>
            <Col>
              <Button
                disabled={disabled()}
                htmlType="submit"
                type="primary"
                className="bg-custom_primary"
              >
                {loading ? (
                  <Spin
                    indicator={<LoadingOutlined style={{ color: "#666666" }} />}
                  />
                ) : (
                  "Agregar"
                )}
              </Button>
            </Col>
          </Row>
        </Form.Item>
      </Form>
    </Modal>
  );
};

AddCompany.propTypes = {
  visible: PropTypes.oneOf(PropTypes.bool, null),
  onComplete: PropTypes.func,
  onCancel: PropTypes.func
}

export default AddCompany;
